import React, { Component } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'
import first from 'lodash/first'
import last from 'lodash/last'
import { bindActionCreators } from 'redux'
import { Currency } from 'components'
import {
  makeSelectPricesByName,
} from 'logic/pcts'
import { resOnly } from 'lib/misc'

import { makeSelectCurOrg } from 'logic/orgs';
import { makeSelectBookingType } from 'logic/orders'

class PriceNameRange extends Component {

  resOrSaleValue = () =>
    this.props.bookingType === 'res' ? 'res_value' : 'value'

  render() {
    const { prices } = this.props

    if (!prices || prices.length < 1) return <></>;
    return (
      <>
        <Currency value={first(prices)[this.resOrSaleValue()]} />
        {prices.length > 1 && first(prices)[this.resOrSaleValue()] !== last(prices)[this.resOrSaleValue()]
          ? <span>
              &nbsp;&ndash;&nbsp;
              <Currency value={last(prices)[this.resOrSaleValue()]} />
            </span>
          : null
        }
      </>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  bookingType: makeSelectBookingType(),
  prices: makeSelectPricesByName(props => props.priceName)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(PriceNameRange)
